import { React, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import AOS from 'aos';
import '../src/assets/font/font-awesome.css';
import routes from './pages';
import Page404 from './pages/404';
import Header from './components/header';
import Footer from './components/footer';
import { TokenProvider } from './contexts/ValutsContext';
import { PoolsProvider } from './contexts/PresaleContext';
import { AlertProvider } from './contexts/AlertContext';
import { SnackbarProvider } from 'notistack';

import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultConfig,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import {
  mainnet,
  avalanche,
  bsc, 
  base
} from 'wagmi/chains';
import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";

const config = getDefaultConfig({
  appName: 'Coingraveyard',
  projectId: process.env.REACT_APP_WALLET_CONNECT_ID,
  chains: [mainnet, base, bsc, avalanche],
  ssr: true,
});

const queryClient = new QueryClient();

export default function App() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <AlertProvider>
            <TokenProvider>
              <PoolsProvider >
                <SnackbarProvider
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                >
                  <Header />
                  <Routes>
                    {routes.map((data, idx) => (
                      <Route
                        key={idx}
                        path={data.path}
                        element={data.component}
                        exact
                      />
                    ))}
                    <Route path="*" element={<Page404 />} />
                  </Routes>
                  <Footer />
                </SnackbarProvider>
              </PoolsProvider >
            </TokenProvider>
          </AlertProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
